import React from 'react';

function IconBase({ children, className = '', title }) {
  return (
    <svg
      aria-hidden={title ? undefined : true}
      className={className}
      fill="none"
      height="20"
      role={title ? 'img' : undefined}
      viewBox="0 0 24 24"
      width="20"
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

export function IconChip({ tone = 'green', children }) {
  return <span className={`icon-chip icon-chip-${tone}`}>{children}</span>;
}

export function TargetIcon(props) {
  return (
    <IconBase {...props}>
			
      {/* Outer Ring */}
      <path d="M 17.33 11.19 c -0.04 0.05 -0.09 0.09 -0.13 0.14 c -0.57 0.57 -1.16 1.02 -1.74 1.38 c 0.8 1.19 1.41 2.4 1.74 3.58 c 0.51 1.78 0.34 3.26 -0.46 4.06 c -0.5 0.5 -1.23 0.75 -2.17 0.75 c -2.39 0 -5.47 -1.59 -8.02 -4.15 C 2.54 12.95 1.54 8.36 3.15 6.76 c 0.5 -0.5 1.23 -0.75 2.17 -0.75 c 1.63 0 3.59 0.74 5.48 2.03 c 0.36 -0.58 0.81 -1.17 1.38 -1.74 c 0.05 -0.05 0.09 -0.09 0.14 -0.13 c -2.34 -1.63 -4.82 -2.56 -6.99 -2.56 c -1.58 0 -2.92 0.5 -3.87 1.45 c -2.86 2.86 -1.36 8.83 3.4 13.59 c 3.04 3.04 6.67 4.85 9.72 4.85 c 1.58 0 2.92 -0.5 3.87 -1.45 c 1.46 -1.46 1.84 -3.74 1.07 -6.42 C 19.09 14.15 18.34 12.64 17.33 11.19 Z" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Inner Rings */}
      <path d="M 7.35 7.82 c -0.84 0 -1.36 0.34 -1.65 0.63 c -0.45 0.45 -1.07 1.5 -0.18 3.5 c 0.5 1.14 1.39 2.38 2.52 3.5 c 1.83 1.83 3.88 2.97 5.36 2.97 c 0.84 0 1.36 -0.34 1.65 -0.63 c 0.45 -0.45 1.07 -1.5 0.18 -3.5 c -0.16 -0.36 -0.37 -0.74 -0.6 -1.12 c -1.79 0.89 -3.31 0.97 -3.4 0.98 c -0.5 0.02 -1 -0.17 -1.35 -0.53 c -0.36 -0.36 -0.55 -0.85 -0.53 -1.35 c 0 -0.09 0.08 -1.6 0.97 -3.39 C 9.24 8.21 8.2 7.82 7.35 7.82 Z" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Bomb */}
      <path d="M 23.48 3.85 c -0.05 -0.2 -0.2 -0.37 -0.41 -0.43 l -2.29 -0.72 l -0.72 -2.29 c -0.06 -0.2 -0.23 -0.35 -0.43 -0.4 c -0.2 -0.05 -0.42 0.01 -0.57 0.16 l -2.08 2.08 c -0.14 0.14 -0.2 0.34 -0.16 0.54 l 0.26 1.31 c -1.22 0.59 -2.75 1.73 -4.06 3.04 c -2.33 2.33 -2.47 5.06 -2.48 5.18 c -0.01 0.17 0.06 0.33 0.18 0.45 c 0.12 0.12 0.28 0.18 0.45 0.18 c 0.12 -0.01 2.85 -0.15 5.18 -2.48 c 1.3 -1.31 2.45 -2.84 3.04 -4.06 l 1.31 0.26 c 0.2 0.04 0.4 -0.02 0.54 -0.16 l 2.08 -2.08 C 23.47 4.27 23.53 4.06 23.48 3.85 Z" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />

    </IconBase>
  );
}

export function DashboardIcon(props) {
  return (
    <IconBase {...props}>
      {/* Top Left Tall Panel */}
      <rect x="3" y="3" width="7" height="9" rx="1" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Top Right Short Panel */}
      <rect x="14" y="3" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Bottom Right Tall Panel */}
      <rect x="14" y="12" width="7" height="9" rx="1" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Bottom Left Short Panel */}
      <rect x="3" y="16" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />

    </IconBase>
  );
}

export function DirectionIcon(props) {
  return (
    <IconBase {...props}>
      {/* Outer Casing */}
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Angled Compass Needle */}
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </IconBase>
  );
}

export function PlanIcon(props) {
  return (
    <IconBase {...props}>
      {/* Outer Folded Outline */}
      <polygon points="3 6 9 3 15 6 21 3 21 19 15 22 9 19 3 22" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Left Crease */}
      <line x1="9" y1="3" x2="9" y2="19" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/*Right Crease */}
      <line x1="15" y1="6" x2="15" y2="22" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </IconBase>
  );
}

export function SprintIcon(props) {
  return (
    <IconBase {...props}>
      {/* Rocket Body and Window */}
      <path d="M 21.65 2.52 a 0.21 0.21 0 0 0 -0.15 -0.16 c -2.55 -0.62 -8.44 1.6 -11.63 4.79 a 13.82 13.82 0 0 0 -1.55 1.83 c -0.98 -0.09 -1.97 -0.01 -2.81 0.35 c -2.37 1.04 -3.06 3.76 -3.25 4.93 a 0.42 0.42 0 0 0 0.46 0.49 l 3.8 -0.42 a 8.45 8.45 0 0 0 0.05 0.86 a 0.85 0.85 0 0 0 0.25 0.52 l 1.47 1.47 a 0.85 0.85 0 0 0 0.52 0.25 a 8.43 8.43 0 0 0 0.85 0.05 l -0.42 3.8 a 0.42 0.42 0 0 0 0.49 0.46 c 1.17 -0.19 3.89 -0.88 4.93 -3.24 c 0.37 -0.84 0.44 -1.82 0.36 -2.8 a 13.78 13.78 0 0 0 1.84 -1.55 C 20.05 10.96 22.26 5.2 21.65 2.52 Z M 14 10.02 a 2 2 0 1 1 2.83 0 A 2 2 0 0 1 14 10.02 Z" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Rocket Exhaust / Flame */}
      <path d="M 5.14 16.5 a 2.11 2.11 0 0 0 -1.24 0.6 C 3.08 17.93 3 21 3 21 s 3.07 -0.08 3.9 -0.91 A 2.1 2.1 0 0 0 7.5 18.86" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </IconBase>
  );
}

export function MovesIcon(props) {
  return (
    <IconBase {...props}>
      {/* Main Rook Outline */}
      <path d="M 6 21 L 8 17 V 10 L 5 6 V 3 H 8 V 6 H 10 V 3 H 14 V 6 H 16 V 3 H 19 V 6 L 16 10 V 17 L 18 21 Z" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Neck Detail */}
      <line x1="8" y1="10" x2="16" y2="10" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />
      
      {/* Base Detail */}
      <line x1="8" y1="17" x2="16" y2="17" stroke="currentColor" strokeWidth="1.8" stroke-linecap="round" stroke-linejoin="round" />

    </IconBase>
  );
}

export function TrackerIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M4 19V5M4 19h16M8 14l3-3 3 2 5-6" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <circle cx="8" cy="14" fill="currentColor" r="1.1" />
      <circle cx="11" cy="11" fill="currentColor" r="1.1" />
      <circle cx="14" cy="13" fill="currentColor" r="1.1" />
      <circle cx="19" cy="7" fill="currentColor" r="1.1" />
    </IconBase>
  );
}

export function ReportsIcon(props) {
  return (
    <IconBase {...props}>
      <rect height="16" rx="2" stroke="currentColor" strokeWidth="1.8" width="14" x="5" y="4" />
      <path d="M9 15V11M12 15V9M15 15V12" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function InsightsIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M12 3a7 7 0 00-4 12.7V19h8v-3.3A7 7 0 0012 3z" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9.5 21h5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function SettingsIcon(props) {
  return (
    <IconBase {...props}>
      <path
        d="M12 8.5A3.5 3.5 0 1012 15.5 3.5 3.5 0 0012 8.5zM19 12a7 7 0 01-.1 1l2 1.6-2 3.4-2.4-1a7.3 7.3 0 01-1.7 1l-.4 2.5h-4l-.4-2.5a7.3 7.3 0 01-1.7-1l-2.4 1-2-3.4L5.1 13A7 7 0 015 12a7 7 0 01.1-1L3 9.4l2-3.4 2.4 1a7.3 7.3 0 011.7-1l.4-2.5h4l.4 2.5a7.3 7.3 0 011.7 1l2.4-1 2 3.4-2.1 1.6c.1.3.1.7.1 1z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </IconBase>
  );
}

export function BellIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M7 10a5 5 0 0110 0v4l1.5 2H5.5L7 14z" stroke="currentColor" strokeWidth="1.8" />
      <path d="M10 18a2 2 0 004 0" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function MessageIcon(props) {
  return (
    <IconBase {...props}>
      <rect height="12" rx="2" stroke="currentColor" strokeWidth="1.8" width="18" x="3" y="5" />
      <path d="M3 8l9 5 9-5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function UserIcon(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5 19a7 7 0 0114 0" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function RocketIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M14 4l6 6-7 7-6-6 7-7z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.8" />
      <circle cx="14" cy="10" r="1.6" stroke="currentColor" strokeWidth="1.6" />
      <path d="M7 17l-3 3M9 19l-5 1 1-5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function ProgressIcon(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 12l4-2" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <circle cx="12" cy="12" fill="currentColor" r="1.2" />
    </IconBase>
  );
}

export function CalendarIcon(props) {
  return (
    <IconBase {...props}>
      <rect height="15" rx="2" stroke="currentColor" strokeWidth="1.8" width="16" x="4" y="5" />
      <path d="M8 3v4M16 3v4M4 9h16" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function ActivityIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M4 12h4l2-4 4 8 2-4h4" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function FilterIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M4 6h16M7 12h10M10 18h4" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function ChevronLeftIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function ChevronRightIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M9 18l6-6-6-6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function EditIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M11 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function TrashIcon(props) {
  return (
    <IconBase {...props}>
      <polyline points="3 6 5 6 21 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M10 11v6M14 11v6" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function MenuIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}

export function CloseIcon(props) {
  return (
    <IconBase {...props}>
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </IconBase>
  );
}
